module.exports = __webpack_public_path__ + "media/src/img/logo-main-32c1bfbc4102f009f6806dfa64bae381.svg";